import { createVNode as o, mergeProps as i } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DelFilled.js";
import s from "../components/PfIcon.js";
const e = (r, l) => {
  const t = {
    ...r,
    ...l.attrs
  };
  return o(s, i(t, {
    icon: m
  }), null);
};
e.displayName = "DelFilled";
e.inheritAttrs = !1;
export {
  e as default
};
